import { TranslateService } from '@ngx-translate/core';
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
var RatingsMapperService = /** @class */ (function () {
    function RatingsMapperService(translate) {
        this.translate = translate;
    }
    RatingsMapperService.prototype.convertRatingsByQuantityData = function (ratingsByQuantity) {
        return [
            {
                name: '1 ' + this.translate.instant('RATINGS.CARDS.GRAPHIC.QUANTITY.STAR'),
                value: ratingsByQuantity.oneStarCount
            },
            {
                name: '2 ' + this.translate.instant('RATINGS.CARDS.GRAPHIC.QUANTITY.STARS'),
                value: ratingsByQuantity.twoStarsCount
            },
            {
                name: '3 ' + this.translate.instant('RATINGS.CARDS.GRAPHIC.QUANTITY.STARS'),
                value: ratingsByQuantity.threeStarsCount
            },
            {
                name: '4 ' + this.translate.instant('RATINGS.CARDS.GRAPHIC.QUANTITY.STARS'),
                value: ratingsByQuantity.fourStarsCount
            },
            {
                name: '5 ' + this.translate.instant('RATINGS.CARDS.GRAPHIC.QUANTITY.STARS'),
                value: ratingsByQuantity.fiveStarsCount
            },
        ];
    };
    RatingsMapperService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RatingsMapperService_Factory() { return new RatingsMapperService(i0.ɵɵinject(i1.TranslateService)); }, token: RatingsMapperService, providedIn: "root" });
    return RatingsMapperService;
}());
export { RatingsMapperService };
